import React, { createContext } from "react"

interface OptionalLabelManagerState {
  showOptionalTags: boolean
  registerField: (fieldId: string, labelHasSpace: boolean) => void
  unregisterField: (fieldId: string) => void
}

const initialState: OptionalLabelManagerState = {
  showOptionalTags: true,
  registerField: () => {},
  unregisterField: () => {}
}

export const OptionalLabelContext =
  createContext<OptionalLabelManagerState>(initialState)

export const useOptionalLabelManager = () => {
  const context = React.useContext(OptionalLabelContext)
  if (context === undefined) {
    throw new Error(
      "useOptionalLabelManager must be used within an OptionalLabelManager"
    )
  }
  return context
}
